import { IEntity, IEquatable } from './entity';
import { Pagination } from './pagination';
import { GlobalQueryParams, QueryParams } from './qs';

export type IPagedResult<T extends IEntity = IEntity> = { docs: T[]; } & Pagination;

export type IQuerable<T extends IEntity = IEntity> = {
  findGlobal<B extends T = T>(params?: GlobalQueryParams, token?: string): Promise<B | undefined>;
  findOne<B extends T = T>(id: IEquatable, params?: QueryParams, token?: string): Promise<B | undefined>;
  findMany<B extends T = T>(params?: QueryParams, token?: string): Promise<B[]>;
  findPaged<B extends T = T>(params?: QueryParams, token?: string): Promise<IPagedResult<B>>;
  create<B extends T = T>(payload: Omit<B, 'id'>, params?: QueryParams, token?: string): Promise<B>;
  updateOne<B extends T = T>(id: IEquatable, payload: Partial<B>, params?: Omit<QueryParams, 'where'>, token?: string): Promise<B>;
  updateMany<B extends T = T>(payload: Partial<B>, params?: QueryParams, token?: string): Promise<B[]>;
  deleteOne<B extends T = T>(id: IEquatable, params?: Omit<QueryParams, 'where'>, token?: string): Promise<B | undefined>;
  deleteMany<B extends T = T>(params?: QueryParams, token?: string): Promise<B[]>;
  // !!! old
  update<B extends T = T>(payload: Partial<B>, params?: QueryParams, token?: string): Promise<B>;
  delete<B extends T = T>(id: IEquatable, token?: string): Promise<B | undefined>;
};

export type FindParams = {
  where?: { [key: string]: unknown },
  market?: string,
  locale?: string,
};

export type FindWhereParams = {
  where: { [key: string]: unknown },
  market?: string,
  locale?: string,
};

export function toFindParams(idOrParams: IEquatable | FindWhereParams): FindWhereParams {
  if (typeof idOrParams === 'number' || typeof idOrParams === 'string') {
    return { where: { id: idOrParams } };
  } else {
    return idOrParams;
  }
}
